import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FinListBalaDiyaList from "./FinListBalaDiyaList";
import { getFinBaladiyaData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function FinBaladiya() {
  const Responsedata = useSelector((state) => state.finBaladiya);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");
  //screen Title Show fun
  const titleBorder = [{ label: "Baladiya", link: "/dashboard/AtmPayroll" }];

  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    dispatch(getFinBaladiyaData(token));
  }, []);

  const updateData = () => {
    dispatch(getFinBaladiyaData(token));
  };

  return (
    <>
      <div className={`ml-5 mr-5 mt-5`}>
        <FinListBalaDiyaList
          titles={[
            "SR.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "Actual Profession",
            "Visa Profession",
            "visa Provider",
            "Sponser Id",
            "Client",
            "IQAMA Number",
            "Baladiya LOCATION",
            "Amount",
            "Baladiya APPLY DATE",
            "Baladiya ISSUE DATE",
            "Baladiya EXPIRE DATE DATE",
            "Baladiya VALID DAYS",
            "STATUS",
            "",
          ]}
          list={Responsedata}
          loading={loading}
          token={token}
          updateData={updateData}
          uploadFile={""}
        />
      </div>
    </>
  );
}
